import React from 'react'
import {Router, route, indexRoute, hashHistory} from "react-router"

import * as firebase from "firebase";


export default class Video extends React.Component {
    constructor(props) {
        super(props);
        this.getVideo = this.getVideo.bind(this);

        this.state = {videoUrl: ''};
    }

    componentWillMount() {
        this.getVideo(this.props.params.id);
    }


    getVideo(id) {
        let storage = firebase.storage();
        let pathReference = storage.ref('videos/'+id);
        var state = this
        pathReference.getDownloadURL().then(function (url) {
                state.setState({videoUrl:url});
        }).catch((err) => {
            console.log(err)
            alert('There was an error, please try again.')

        })

    }
    render() {
        return <div id="image_content" background-color="black">
            <div id="image_container" className="card" margin="auto" >
                <div id="image">  <video controls className="card-img-center" src={this.state.videoUrl} width="100%" height="100%"  >
                    <source src={this.state.videoUrl} type="video/mp4"/>
                </video></div>
                <div id="download"><button id="dowload" className="btn btn-success btn-block" ><a href={this.state.videoUrl  } download >Download</a></button></div>

            </div>
        </div>


    }
}



// WEBPACK FOOTER //
// ./src/components/pages/Video.jsx